import { gql } from "@apollo/client";

export const ORGANIZATIONS = gql`
  query Organizations(
    $where: OrganizationWhereInput
    $take: Int
    $skip: Int
    $like: OrganizationWhereInput
  ) {
    organizations(where: $where, take: $take, skip: $skip, like: $like) {
      data {
        id
        name
        type
        active
        siretNumber
        telecoms {
          id
          system
          value
        }
        counterpartyContracts {
          id
          legalState
          expirationType
          type
          issuanceDate
          createdDate
        }
        insurancePlans {
          id
        }
        users {
          id
          gender
          firstname
          lastname
          phone
          email
          meta
        }
      }
      count
    }
  }
`;

export const ORGANIZATION = gql`
  query Organization($where: OrganizationWhereInput, $exclude: [String]) {
    organization(where: $where, exclude: $exclude) {
      id
      name
      type
      active
      siretNumber
      config
      broker {
        id
      }
      telecoms {
        id
        system
        value
      }
      counterpartyContracts {
        id
        identifier
        legalState
        expirationType
        type
        issuanceDate
        createdDate
        subjects
      }
      insurancePlans {
        id
      }
      users {
        id
        gender
        firstname
        lastname
        phone
        email
        meta
      }
    }
  }
`;

export const ORGANIZATION_BRANCHES = gql`
  query OrganizationBranches($where: OrganizationWhereInput) {
    organizationBranches(where: $where) {
      count
      data {
        id
        name
        type
        telecoms {
          value
        }
      }
    }
  }
`;

const organizations = { ORGANIZATIONS, ORGANIZATION, ORGANIZATION_BRANCHES };

export default organizations;
